<template>
    <v-card-component :title="getTitle"
      :icon="parentType === 'mother' ? 'mdi-human-female' : 'mdi-human-male'" @close="handleCloseIcon" :isCloseIcon="showCloseIcon">
      <v-row>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='father'">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    {{parentLabel}} Name
                    <span class="error--text">*</span>
                </span>
                <ApproveRejectButton
                    v-if="value[`${parentType}Name`] && (value[`${parentType}Name`] !== compareStudentData[`${parentType}Name`])"
                    :fieldType="`${parentType}Name`"
                    :fieldValue="value[`${parentType}Name`]"
                    @click="approveRejectPersonalRequest"
                />
            </div>
            <v-text-field
                type="text"
                placeholder="Name"
                class="my-0 py-1"
                :class="value[`${parentType}Name`] && (value[`${parentType}Name`] !== compareStudentData[`${parentType}Name`])? 'custom-text-color' : ''"
                :value = "value[`${parentType}Name`] ? value[`${parentType}Name`] : compareStudentData[`${parentType}Name`]"
                disabled
                single-line
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='mother'">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    {{parentLabel}} Name
                    <span class="error--text">*</span>
                </span>
                <ApproveRejectButton
                    v-if="value[`${parentType}Name`] && (value[`${parentType}Name`] !== compareStudentData[`${parentType}Name`])"
                    :fieldType="`${parentType}Name`"
                    :fieldValue="value[`${parentType}Name`]"
                    @click="approveRejectPersonalRequest"
                />
            </div>
            <v-text-field
                type="text"
                placeholder="Name"
                :class="value[`${parentType}Name`] && (value[`${parentType}Name`] !== compareStudentData[`${parentType}Name`])? 'custom-text-color' : ''"
                :value="value[`${parentType}Name`] ? value[`${parentType}Name`] : compareStudentData[`${parentType}Name`]"
                class="my-0 py-1"
                single-line
                disabled
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='guardian'">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    {{parentLabel}} Name
                </span>
                <ApproveRejectButton
                    v-if="value[`${parentType}Name`] && (value[`${parentType}Name`] !== compareStudentData[`${parentType}Name`])"
                    :fieldType="`${parentType}Name`"
                    :fieldValue="value[`${parentType}Name`]"
                    @click="approveRejectPersonalRequest"
                />
            </div>
            <v-text-field
                placeholder="Name"
                :value="value[`${parentType}Name`] ? value[`${parentType}Name`] : compareStudentData[`${parentType}Name`]"
                class="my-0 py-1"
                :class="value[`${parentType}Name`] && (value[`${parentType}Name`] !== compareStudentData[`${parentType}Name`])? 'custom-text-color' : ''"
                single-line
                disabled
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='father'">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    {{parentLabel}} Mobile No
                    <span class="error--text">*</span>
                </span>
                <ApproveRejectButton
                    v-if="value[`${parentType}Mobile`] && (value[`${parentType}Mobile`] !== compareStudentData[`${parentType}Mobile`])"
                    :fieldType="`${parentType}Mobile`"
                    :fieldValue="value[`${parentType}Mobile`]"
                    @click="approveRejectPersonalRequest"
                />
            </div>
          <v-text-field
            placeholder="Mobile No"
            class="my-0 py-1"
            single-line
            type="text"
            :class="value[`${parentType}Mobile`] && (value[`${parentType}Mobile`] !== compareStudentData[`${parentType}Mobile`]) ? 'custom-text-color' : ''"
            :value="value[`${parentType}Mobile`] ? value[`${parentType}Mobile`] : compareStudentData[`${parentType}Mobile`]"
            maxlength="10"
            disabled
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          />
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='mother'">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    {{parentLabel}} Mobile No
                    <span class="error--text" v-if="parentType ==='mother'">*</span>
                </span>
                <ApproveRejectButton
                v-if="value[`${parentType}Mobile`] && (value[`${parentType}Mobile`] !== compareStudentData[`${parentType}Mobile`])"
                    :fieldType="`${parentType}Mobile`"
                    :fieldValue="value[`${parentType}Mobile`]"
                    @click="approveRejectPersonalRequest"
                />
            </div>
            <v-text-field
                placeholder="Mobile No"
                type="number"
                class="my-0 py-1"
                single-line
                :class="value[`${parentType}Mobile`] && (value[`${parentType}Mobile`] !== compareStudentData[`${parentType}Mobile`]) ? 'custom-text-color' : ''"
                :value="value[`${parentType}Mobile`] ? value[`${parentType}Mobile`] : compareStudentData[`${parentType}Mobile`]"
                maxlength="10"
                disabled
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='guardian'">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    {{parentLabel}} Mobile No
                </span>
                <ApproveRejectButton
                  v-if="value[`${parentType}Mobile`] && (value[`${parentType}Mobile`] !== compareStudentData[`${parentType}Mobile`])"
                  :fieldType="`${parentType}Mobile`"
                  :fieldValue="value[`${parentType}Mobile`]"
                  @click="approveRejectPersonalRequest"
                />
            </div>
            <v-text-field
                placeholder="Mobile No"
                :value="value[`${parentType}Mobile`] ? value[`${parentType}Mobile`] : compareStudentData[`${parentType}Mobile`]"
                type="number"
                class="my-0 py-1"
                single-line
                maxlength="10"
                disabled
                :class="value[`${parentType}Mobile`] && (value[`${parentType}Mobile`] !== compareStudentData[`${parentType}Mobile`]) ? 'custom-text-color' : ''"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='father'">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    {{parentLabel}} Email
                    <span class="error--text">*</span>
                </span>
                <ApproveRejectButton
                    v-if="value[`${parentType}EmailID`] && (value[`${parentType}EmailID`] !== compareStudentData[`${parentType}EmailID`])"
                    :fieldType="`${parentType}EmailID`"
                    :fieldValue="value[`${parentType}EmailID`]"
                    @click="approveRejectPersonalRequest"
                />
            </div>
            <v-text-field
                placeholder="Email"
                type="email"
                class="my-0 py-1"
                single-line
                disabled
                :class="value[`${parentType}EmailID`] && (value[`${parentType}EmailID`] !== compareStudentData[`${parentType}EmailID`]) ? 'custom-text-color' : ''"
                :value="value[`${parentType}EmailID`] ? value[`${parentType}EmailID`] : compareStudentData[`${parentType}EmailID`]"
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='mother'">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    {{parentLabel}} Email
                    <span class="error--text">*</span>
                </span>
                <ApproveRejectButton
                v-if="value[`${parentType}EmailID`] && (value[`${parentType}EmailID`] !== compareStudentData[`${parentType}EmailID`])"
                    :fieldType="`${parentType}EmailID`"
                    :fieldValue="value[`${parentType}EmailID`]"
                    @click="approveRejectPersonalRequest"
                />
            </div>
            <v-text-field
                placeholder="Email"
                :value="value[`${parentType}EmailID`] ? value[`${parentType}EmailID`] : compareStudentData[`${parentType}EmailID`]"
                type="email"
                class="my-0 py-1"
                single-line
                disabled
                :class="value[`${parentType}EmailID`] && (value[`${parentType}EmailID`] !== compareStudentData[`${parentType}EmailID`]) ? 'custom-text-color' : ''"
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='guardian'">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    {{parentLabel}} Email
                </span>
                <ApproveRejectButton
                v-if="value[`${parentType}EmailID`] && (value[`${parentType}EmailID`] !== compareStudentData[`${parentType}EmailID`])"
                    :fieldType="`${parentType}EmailID`"
                    :fieldValue="value[`${parentType}EmailID`]"
                    @click="approveRejectPersonalRequest"
                />
            </div>
            <v-text-field
                placeholder="Email"
                :value="value[`${parentType}EmailID`] ? value[`${parentType}EmailID`] : compareStudentData[`${parentType}EmailID`]"
                type="email"
                class="my-0 py-1"
                single-line
                disabled
                :class="value[`${parentType}EmailID`] && (value[`${parentType}EmailID`] !== compareStudentData[`${parentType}EmailID`]) ? 'custom-text-color' : ''"
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="formType !== 'studEdit' && parentType!=='guardian' ">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    {{parentLabel}} Occupation
                </span>
                <ApproveRejectButton
                    v-if="value[`${parentType}Occupation`] && (value[`${parentType}Occupation`] !== compareStudentData[`${parentType}Occupation`])"
                    :fieldType="`${parentType}Occupation`"
                    :fieldValue="value[`${parentType}Occupation`]"
                    @click="approveRejectPersonalRequest"
                />
            </div>
            <v-text-field
                type="text"
                placeholder="Occupation"
                :value="value[`${parentType}Occupation`] ? value[`${parentType}Occupation`] : compareStudentData[`${parentType}Occupation`]"
                class="my-0 py-1"
                single-line
                disabled
                :class="value[`${parentType}Occupation`] && (value[`${parentType}Occupation`] !== compareStudentData[`${parentType}Occupation`] ) ? 'custom-text-color' : ''"
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6"
            v-if="(formType == 'edit_registration' ||
            formType==='registration' ||
            formType==='admission') &&
            parentType!=='guardian'"
        >
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    {{parentLabel}} Designation
                </span>
                <ApproveRejectButton
                    v-if="value[`${parentType}Designation`] && (value[`${parentType}Designation`] !== compareStudentData[`${parentType}Designation`])"
                    :fieldType="`${parentType}Designation`"
                    :fieldValue="value[`${parentType}Designation`]"
                    @click="approveRejectPersonalRequest"
                />
            </div>
            <v-text-field
                type="text"
                placeholder=" Designation"
                :value="value[`${parentType}Designation`] ? value[`${parentType}Designation`] : compareStudentData[`${parentType}Designation`]"
                class="my-0 py-1"
                single-line
                disabled
                :class="value[`${parentType}Designation`] && (value[`${parentType}Designation`] !== compareStudentData[`${parentType}Designation`]) ? 'custom-text-color' : ''"
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6"
          v-if="(
            formType == 'edit_registration' ||
            formType==='registration' ||
            formType==='admission' ) &&
            parentType!=='guardian'"
        >
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    {{parentLabel}} Qualification
                </span>
                <ApproveRejectButton
                    v-if="value[`${parentType}Qualification`] && (value[`${parentType}Qualification`] !== compareStudentData[`${parentType}Qualification`])"
                    :fieldType="`${parentType}Qualification`"
                    :fieldValue="value[`${parentType}Qualification`]"
                    @click="approveRejectPersonalRequest"
                />
            </div>
            <v-text-field
                type="text"
                placeholder="Qualification"
                :value="value[`${parentType}Qualification`] ? value[`${parentType}Qualification`] : compareStudentData[`${parentType}Qualification`]"
                class="my-0 py-1"
                single-line
                disabled
                :class="value[`${parentType}Qualification`] && (value[`${parentType}Qualification`] !== compareStudentData[`${parentType}Qualification`]) ? 'custom-text-color' : ''"
            />
        </v-col>
    </v-row>
    <v-row
        v-if="(
            formType == 'edit_registration' ||
            formType==='registration' ||
            formType==='admission'
        ) && parentType!=='guardian'"
    >
        <v-col cols="12" lg="4" sm="6">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    {{parentLabel}} Organisation
                </span>
                <ApproveRejectButton
                    v-if="value[`${parentType}Organisation`] && (value[`${parentType}Organisation`] !== compareStudentData[`${parentType}Organisation`])"
                    :fieldType="`${parentType}Organisation`"
                    :fieldValue="value[`${parentType}Organisation`]"
                    @click="approveRejectPersonalRequest"
                />
            </div>
            <v-text-field
                type="text"
                placeholder="Organisation"
                :value="value[`${parentType}Organisation`] ? value[`${parentType}Organisation`] : compareStudentData[`${parentType}Organisation`]"
                class="my-0 py-1"
                single-line
                disabled
                :class="value[`${parentType}Organisation`] && (value[`${parentType}Organisation`] !== compareStudentData[`${parentType}Organisation`]) ? 'custom-text-color' : ''"
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType!=='guardian'">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    {{parentLabel}} Office Phone No
                </span>
                <ApproveRejectButton
                    v-if="value[`${parentType}OfficePhoneNo`] && (value[`${parentType}OfficePhoneNo`] !== compareStudentData[`${parentType}OfficePhoneNo`])"
                    :fieldType="`${parentType}OfficePhoneNo`"
                    :fieldValue="value[`${parentType}OfficePhoneNo`]"
                    @click="approveRejectPersonalRequest"
                />
            </div>
            <v-text-field
                placeholder="Office Phone No"
                :value="value[`${parentType}OfficePhoneNo`] ? value[`${parentType}OfficePhoneNo`] : compareStudentData[`${parentType}OfficePhoneNo`]"
                type="number"
                onKeyPress="if(this.value.length==10) return false;"
                class="my-0 py-1"
                disabled
                :class="value[`${parentType}OfficePhoneNo`] && (value[`${parentType}OfficePhoneNo`] !== compareStudentData[`${parentType}OfficePhoneNo`])  ? 'custom-text-color' : ''"
                single-line
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType!=='guardian'">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    {{parentLabel}} Office Address
                </span>
                <ApproveRejectButton
                    v-if="value[`${parentType}OfficeAddress`] && (value[`${parentType}OfficeAddress`] !== compareStudentData[`${parentType}OfficeAddress`])"
                    :fieldType="`${parentType}OfficeAddress`"
                    :fieldValue="value[`${parentType}OfficeAddress`]"
                    @click="approveRejectPersonalRequest"
                />
            </div>
            <v-text-field
                type="text"
                placeholder="Office Address"
                :value="value[`${parentType}OfficeAddress`] ? value[`${parentType}OfficeAddress`] : compareStudentData[`${parentType}OfficeAddress`]"
                class="my-0 py-1"
                disabled
                :class="value[`${parentType}OfficeAddress`] && (value[`${parentType}OfficeAddress`] !== compareStudentData[`${parentType}OfficeAddress`]) ? 'custom-text-color' : ''"
                single-line
            />
        </v-col>
    </v-row>
    </v-card-component>
</template>
<script>
import constants from '@/utils/constants'
import VCardComponent from '@/components/template/VCardComponent'
import ApproveRejectButton from '@/components/Forms/Elements/ApproveRejectButtonElement'
export default {
  name: 'ApproveRegParentElement',
  components: { VCardComponent, ApproveRejectButton },
  data: function () {
    return {
      isReadonly: false,
      isDisabled: false,
      isRequired: false,
      parentLabel: '',
      getTitle: '',
      showGaurdianButton: false,
      showCloseIcon: false
    }
  },
  props: {
    formType: {
      default: '',
      type: String
    },
    parentType: {
      default: '',
      type: String
    },
    pointOfContact: {
      default: '',
      type: String
    },
    value: {
      default: () => {},
      type: Object
    },
    isWritable: {
      default: 'false',
      type: String
    },
    compareStudentData: {
      default: () => {},
      type: Object
    },
    enquiryID: {
      default: null,
      type: String
    }
  },
  mounted () {
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
  },
  watch: {
    parentType: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.OnRequestTabClick()
      }
    }
  },
  created () {
    this.OnRequestTabClick()
  },
  methods: {
    closeFullScreenPopup () {
      this.showGaurdianButton = true
      this.$emit('setIsCompop', this.showGaurdianButton)
    },
    handleCloseIcon () {
      this.showGaurdianButton = false
      this.$emit('closeIcon', this.showGaurdianButton)
    },
    OnRequestTabClick: function () {
      if (this.parentType === 'mother') {
        this.parentLabel = 'Mother'
        this.getTitle = "Mother's Details"
        this.showGaurdianButton = true
      } else if (this.parentType === 'father') {
        this.parentLabel = 'Father'
        this.getTitle = "Father's Details"
      } else if (this.parentType === 'guardian') {
        this.parentLabel = 'Gaurdian'
        this.getTitle = 'Gaurdian Details'
        this.showCloseIcon = true
      }
      if (this.isWritable === 'false') {
        this.isReadonly = true
        this.isDisabled = true
      }
      if (this.formType === 'edit_registration' && this.parentType === 'father') {
        this.isRequired = true
      }
    },
    approveRejectPersonalRequest: async function (data, type) {
      try {
        let title = ''
        let confirmText = ''
        let popupColor = ''
        if (type === 'Approve') {
          title = 'Approve field request'
          confirmText = "Please confirm to update the request for approval of Parent/Guardian's Details for all the kids associated with the requester's account."
          popupColor = 'info'
        } else {
          title = 'Reject field request.'
          confirmText = 'Are you sure you want to reject the requested changes?'
          popupColor = 'error'
        }
        this.$dialog.confirm({
          title: title,
          text: confirmText,
          type: popupColor,
          actions: {
            false: {
              text: type === 'Approve' ? 'Cancel' : 'No',
              handle: () => {
                this.$nextTick(() => {
                  return false
                })
              }
            },
            true: {
              color: 'success',
              text: type === 'Approve' ? 'Confirm' : 'Yes',
              handle: async () => {
                try {
                  let payload = {}
                  payload.statusType = type
                  payload.id = this.value.id
                  payload.type = 'personal'
                  payload.isChange = this.parentType
                  payload.enquiryID = this.enquiryID
                  payload[data.fieldType] = data.fieldValue
                  const res = await http.post(`${constants.API_URL}/api/student/v1/approve-edited-information`, payload)
                  if (res.status === 200) {
                    this.okMsg(res.data)
                    this.$emit('onStart')
                  }
                } catch (e) {
                  const errorMessage = (e && e.response && e.response.data.message) || e.message
                  this.errMsg(errorMessage)
                }
              }
            }
          }
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style>
.custom-text-color > div.v-input__control > div.v-input__slot > div.v-text-field__slot > input{
    color:#ff0000!important;
}
</style>
